import { Link } from 'react-router-dom';

import routeFactory from '../../../../../../../common/util/routeFactory';

export const IssuerCellRenderer = ({
  value,
  data,
}: {
  value: string | null | undefined;
  data: { offeringId: string };
}) => {
  const href = routeFactory.offerings.getUrlPath({ id: data?.offeringId });

  return <Link to={href}>{value}</Link>;
};
